import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../store/database';
import { SUPPORTED_LANGUAGES, TIER_LABELS, MEMBER_STATUSES } from '../../config/house.config';
import type { SupportedLang } from '../../config/house.config';

export default function AccountPage() {
  const { t, i18n } = useTranslation();
  const member = useStore(s => s.getMember());
  const user = useStore(s => s.getUser());
  const updateMemberLang = useStore(s => s.updateMemberLang);
  const [saved, setSaved] = useState(false);

  if (!member || !user) return null;

  const handleLangChange = (lang: SupportedLang) => {
    updateMemberLang(member.id, lang);
    i18n.changeLanguage(lang);
    localStorage.setItem('ah_language', lang);
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  return (
    <div className="space-y-8 max-w-lg">
      <h1 className="font-serif text-2xl tracking-widest">{t('account.title')}</h1>

      <div className="space-y-4">
        <div className="flex justify-between border-b border-charcoal/5 pb-3">
          <span className="text-[11px] tracking-widest uppercase text-charcoal/40 font-sans">{t('account.memberCode')}</span>
          <span className="font-mono text-sm">{member.member_code}</span>
        </div>
        <div className="flex justify-between border-b border-charcoal/5 pb-3">
          <span className="text-[11px] tracking-widest uppercase text-charcoal/40 font-sans">{t('account.status')}</span>
          <span className="font-sans text-sm capitalize">{member.status}</span>
        </div>
        <div className="flex justify-between border-b border-charcoal/5 pb-3">
          <span className="text-[11px] tracking-widest uppercase text-charcoal/40 font-sans">{t('account.tier')}</span>
          <span className="font-serif">{TIER_LABELS[member.access_tier]}</span>
        </div>
        <div className="flex justify-between items-center border-b border-charcoal/5 pb-3">
          <span className="text-[11px] tracking-widest uppercase text-charcoal/40 font-sans">{t('account.language')}</span>
          <div className="flex gap-1">
            {SUPPORTED_LANGUAGES.map(l => (
              <button key={l} onClick={() => handleLangChange(l)}
                className={`px-2 py-1 text-[10px] tracking-widest uppercase font-sans transition-colors ${user.preferred_language === l ? 'bg-charcoal text-ivory' : 'text-charcoal/30 hover:text-charcoal'}`}>
                {l.toUpperCase()}
              </button>
            ))}
          </div>
        </div>
      </div>

      {saved && <p className="text-xs text-gold font-sans">{t('account.saved')}</p>}

      {/* Status messages for non-active members */}
      {member.status !== 'active' && (
        <div className="border border-burgundy/20 p-4 text-sm font-sans text-burgundy/70">
          {t(`status.${member.status}`)}
        </div>
      )}
    </div>
  );
}
